<div class="documentation-page">
  <div #documentationPageContent class="documentation-page_content row no-gutters d-flex flex-nowrap position-relative">
    <div class="documentation-page_content_menu">
      <si-vertical-menu [items]="items"></si-vertical-menu>
    </div>
    <div class="documentation-page_content_outlet col">
      <router-outlet (activate)="onActivateRouterOutlet($event)"></router-outlet>
    </div>
  </div>
</div>
